import get from "lodash/get";
import { setCookie, getCookie } from "cookies-next";

// helpers
import useUserProfile from "./useUserProfile";
import account from "@/api/query/account";
import currencies from "@/api/query/currencies";

// interfaces
import { ICurrency } from "@/types/api/Currency";


function useCurrency(): [string, (currencyObj: Partial<ICurrency>) => Promise<void>] {
  const { data = getCookie("currency") || "GBP", refetch } = currencies.useCurrentCurrency();

  const useUserProfileUtils = useUserProfile();
  const { mutateAsync } = account.useUpdateProfile();

  const currentCurrency = useUserProfileUtils.isAuthorized ? get(useUserProfileUtils, "data.preferences.currency.code", data) : data;

  const onChangeCurrency = async (currencyObj: Partial<ICurrency>) => {
    setCookie("currency", currencyObj.code as string); // also required to update when user is authorized, because this value use when user data is loading and can trigger additional requests if the user currency does not match the cookie currency

    if (!useUserProfileUtils.isAuthorized) {
      refetch();

      return;
    }

    await mutateAsync({ preferences: { currency: currencyObj.id } }).then(() => useUserProfileUtils.refetch());
  };

  return [currentCurrency, onChangeCurrency];
}


export default useCurrency;
